import React from 'react';
import NProgress from 'nprogress';
import { Modal } from '@avila-tek/ui/src';
import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';
import { Product, ShopCart, ShopItem, User, Variant } from '../../../../models';
import { EmployeeList, ProductItem } from '../../../shared/AssignModal';
import { ADD_ITEM_TO_SHOP_CART } from '../../../../graphql/mutation';
import { useNotify, useShopCart } from '../../../../hooks';
import ProductItemCard from './ProductItemCard';
import TotalItem from '../../../shared/AssignModal/TotalItem';
import AssignModalButtons from '../../../shared/AssignModal/AssignModalButtons';

interface AddProductModalProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  product: Product;
  variant: Variant;
}

function AddProductModal({
  isOpen,
  setOpen,
  product,
  variant,
}: AddProductModalProps) {
  const router = useRouter();
  const notify = useNotify();
  const [shopCart, setShopCart] = useShopCart();

  const [shopList, setShopList] = React.useState<ShopItem[]>([]);
  const [disabled, setDisabled] = React.useState(false);

  const [addItemToShopCartMutation] = useMutation<{
    addItemToShopCart: ShopCart;
  }>(ADD_ITEM_TO_SHOP_CART);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      if (disabled) return;
      NProgress.start();
      setDisabled(true);

      const { data } = await addItemToShopCartMutation({
        variables: {
          data: {
            shopCart: shopCart._id,
            items: {
              variant: variant._id,
              shopList: shopList.map((c) => ({
                client: (c.client as User).client._id,
                quantity: c.quantity,
              })),
            },
          },
        },
      });
      if (data?.addItemToShopCart?._id) {
        notify('Se ha agreagado al carrito con éxito', 'success');
        setShopCart(data?.addItemToShopCart);
      } else {
        notify('Ha ocurrido un error al intentar agregar al carrito', 'error');
      }
      router.push('/app/shopcart');
    } catch (error) {
      console.log(error);
      notify(error.message, 'error');
    } finally {
      setDisabled(false);
      NProgress.done();
    }
  };

  const getTotalQuantity = () => {
    let total = 0;
    shopList.forEach((c) => {
      total += c.quantity;
    });
    return total;
  };

  const variantTitle = `${variant?.option?.option1 ?? ''} ${
    variant?.option?.option2 ?? ''
  } ${variant?.option?.option3 ?? ''}`;

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      className="md:max-w-[60%] md:ml-72 "
    >
      <form method="POST" onSubmit={onSubmit}>
        <div className="bg-white rounded-lg ">
          <Modal.Title title="Asignar a beneficiario" setIsOpen={setOpen} />
          <div className="flex flex-col p-6">
            {/* description */}
            {/* FIXME: What should it be written here? I put a sample text but i don't know if it is right */}
            <span className="text-text-gray">
              Aquí podrás asignar el producto seleccionado a los beneficiarios
              de tu compañía para que puedan adquirirlo.
            </span>
            <ProductItemCard product={product} variant={variant} />
            <EmployeeList
              variant={variant}
              type="product"
              shopList={shopList}
              setShopList={setShopList}
            />
            <div className="w-full flex flex-col mt-5">
              {getTotalQuantity() > 0 ? (
                <ProductItem
                  title={product.title}
                  subtitle={variantTitle}
                  quantity={getTotalQuantity()}
                  price={variant.price}
                />
              ) : null}
            </div>
            <TotalItem total={getTotalQuantity() * (variant?.price ?? 0)} />
            <AssignModalButtons />
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default AddProductModal;
